import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "src/App.tsx"
import { store } from "src/shared/store/store.ts"
import { Provider } from "react-redux"
import { CssBaseline } from "@mui/material"
import GlobalStyle from "src/shared/css/global-style"
import { ThemeContextProvider } from "src/shared/context/theme-context"
import "./shared/css/global.css"
import { GlobalConfigProvider } from "src/shared/context/globalConfigContext"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import ToastifyAlert from "./shared/container/toastify-alert"
import ErrorBoundary from "./modules/error/error-baundary"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <GlobalConfigProvider>
          <ThemeContextProvider>
            <ToastifyAlert />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <CssBaseline />
              <GlobalStyle />
              <App />
            </LocalizationProvider>
          </ThemeContextProvider>
        </GlobalConfigProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>
)
